import {useState} from "../../../__snowpack__/pkg/react.js";
import {createModel} from "../../../__snowpack__/pkg/hox.js";
import {axios as defaultAxios} from "../../lib/axios.js";
import {handleError} from "../../lib/errorHandler.js";
export const useBlibliProductList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (params) => {
    setLoading(true);
    try {
      const {data: data2} = await defaultAxios.post(`/saas/product/get-product-list`, params);
      setData(data2);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  return {
    blibliProductListLoading: loading,
    blibliProductList: data,
    fetchBlibliProductList: fetchData
  };
};
export const useBlibliProductListModel = createModel(useBlibliProductList);
export const useBlibliShopList = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const fetchData = async (shopIds) => {
    setLoading(true);
    try {
      const {data: data2} = await defaultAxios.get(`/saas/shop/get-list-by-shop-ids`, {
        params: {
          shopIds
        }
      });
      setData(data2);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  return {
    blibliShopListLoading: loading,
    blibliShopList: data,
    fetchBlibliShopList: fetchData
  };
};
export const useBlibliShopListModel = createModel(useBlibliShopList);
export const BlibliBatchModifyCategoryAttributes = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const fetchData = async (params) => {
    setLoading(true);
    try {
      const {data: data2} = await defaultAxios.post(`/saas/product/batch-modify-category-attributes`, params);
      setData(data2);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  return {
    blibliModifyLoading: loading,
    blibliModify: data,
    fetchBlibliModify: fetchData
  };
};
export const BlibliBatchModifyCategoryAttributesModel = createModel(BlibliBatchModifyCategoryAttributes);
export const useBlibliVariationList = () => {
  const [data, setData] = useState({});
  const [attrMapData, setAttrMapData] = useState({});
  const [mandatoryMap, setMandatoryMap] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (params) => {
    setLoading(true);
    try {
      const defaultData = await defaultAxios.post(`/saas/shop/get-categoryAttributes-list-by-channel`, params);
      let variationMap = {};
      let dataAttributesMap = {};
      let mandaMap = [];
      defaultData && defaultData.data.map((data2) => {
        variationMap[data2.categoryId] = [];
        mandaMap[data2.categoryId] = [];
        dataAttributesMap[data2.categoryId] = {};
        if (data2.attributes && data2.attributes.length) {
          data2.attributes.map((attrData) => {
            if (attrData.mandatory === true && !attrData.variantCreating && !attrData.specialAttribute) {
              mandaMap[data2.categoryId] = [...mandaMap[data2.categoryId], attrData];
            } else if (attrData.variantCreating === true && attrData.attributeName === "Warna") {
              let attributeList = data2.attributes.filter((_) => _.specialAttribute && _.attributeName === "Family Colour");
              dataAttributesMap[data2.categoryId][attrData.attributeId] = {
                ...attrData,
                type: attributeList && attributeList.length ? "INPUT_SELECT" : "TEXT",
                options: attributeList && attributeList[0]?.options || []
              };
              variationMap[data2.categoryId] = [...variationMap[data2.categoryId], attrData];
            } else if (attrData.variantCreating === true) {
              dataAttributesMap[data2.categoryId][attrData.attributeId] = attrData;
              variationMap[data2.categoryId] = [...variationMap[data2.categoryId], attrData];
            }
          });
        }
      });
      setAttrMapData({...attrMapData, ...dataAttributesMap});
      setMandatoryMap({...mandatoryMap, ...mandaMap});
      setData({...data, ...variationMap});
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  return {
    blibliVariationMapLoading: loading,
    blibliVariationMap: data,
    blibliAttrMapData: attrMapData,
    mandatoryMap,
    fetchBlibliVariationMap: fetchData
  };
};
export const useBlibliVariationListModel = createModel(useBlibliVariationList);
